export const NEWS_STATUS_PUBLISHED = { status: 1, name: 'Paskelbta' };
export const NEWS_STATUS_NOT_PUBLISHED = { status: 0, name: 'Ne paskelbta' };